import Vimeo from '@vimeo/player'

$.fn.videoPlayer = function() {
  let self = this


    self.player = new Vimeo(self.get(0));
    var status = $('.status');

    self.player.on('ended', function() {
      $(".single-project__video").removeClass("--playing");
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    });

    $('.single-project__play').on('click', function() {
      $(".single-project__video").addClass("--playing");
      self.player.play();
      return false;
    });


    $(".no-touch .single-project__play").on("mouseover", function() {
      $(this).text(colossale_l10n.click);
    }).on("mouseout", function() {
      $(this).text(colossale_l10n.play);
    });

  return function() {
    return self
  }()
}
